import Base from 'app/collections/base';
import { appUrl } from 'utils/wrappers';
import Webhook from 'app/models/webhook';

export default Base.extend({
  model: Webhook,
  key: 'webhooks',
  url: appUrl('webhooks'),

  initialize(models, { apiModeSelection }) {
    this.apiModeSelection = apiModeSelection;
  },

  paramsForFetch() {
    return { ...this.apiModeSelection.getParams() };
  },
});



// WEBPACK FOOTER //
// ./app/collections/webhooks.js